import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/sav.svg';
export default {
  name: 'Phone',
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    serviceNumber: 'i18n/serviceNumber'
  }), {
    localServiceNumber: function localServiceNumber() {
      var _this = this;

      return this.serviceNumber.filter(function (s) {
        return _this.locale.market === s.market && _this.locale.language === s.language;
      });
    }
  })
};